import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { base_url } from "../../../../config";

const ReportTable = ({ tableId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hostComplaint, setHostComplaint] = useState("");
  const token = localStorage.getItem("@user");

  const handleSubmit = async () => {
  const url = `${base_url}/report/create-host`;
    const body = {
      table_id: tableId,
      host_complaint: hostComplaint,
    };

    try {
      const response = await axios.post(url, body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("API Response:", response.data);
      toast.success("Feedback Submitted successfully!", {
        position: "top-right",
      });
      setIsModalOpen(false);
      setHostComplaint(""); // Clear the input after submission
    } catch (error) {
      if (error.response) {
        console.error("API Error:", error.response.data);
        toast.error("Feedback Already Submitted!", {
          position: "top-right",
        });
      } else if (error.request) {
        console.error("No Response:", error.request);
        toast.error("No Response from Server!", {
          position: "top-right",
        });
      } else {
        console.error("Error:", error.message);
        toast.error("An Error Occurred!", {
          position: "top-right",
        });
      }
    }
  };

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="bg-gray-900 text-white py-2 px-4 rounded hover:bg-[#E2B760]"
      >
        Feedback
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999] p-5 sm:p-0">
          <div className="bg-white w-96 p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Feedback
            </h2>
            <textarea
              value={hostComplaint}
              onChange={(e) => setHostComplaint(e.target.value)}
              placeholder="Write your feedback here"
              className="w-full p-2 border text-black border-gray-300 rounded-lg focus:outline-none focus:ring-2 mb-4"
            />
            <div className="flex justify-end space-x-4">
              <button
                onClick={handleSubmit}
                className="bg-[#e2b760] text-white py-2 px-4 rounded hover:bg-green-700"
              >
                Submit
              </button>
              <button
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-300 text-gray-800 py-2 px-4 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportTable;
